import React from "react";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3PageTitle from "../../../core/et3-page-title/index";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import ET3PageDiv from "../../../core/et3-page-div";
import Form from "./form";
import Data from "./data";

const TurnOnOffKhattabat = withLiteObserverAndTheme(() => {
  React.useEffect(() => {
    getCoreHistoryStore().setPageName(
      "SUPERVISOR_TURN_ON_OFF_KHATTABAT",
      "SUPERVISOR_TURN_ON_OFF_KHATTABAT"
    );
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("ADMIN")}
        subTitle={i18n.get("TURN_KHATTABAT_ON_OFF")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />

      <Form />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Data />
    </ET3PageDiv>
  );
});
export default TurnOnOffKhattabat;
